import React from 'react';
import Tooltip from './Tooltip';
import { Leader } from './types';

const chipColors = {
  politics: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  employment: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200',
  excommunicated: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
};

// chips show a cleaned first clause; the full value lives in the tooltip
const shorten = (value: string) => {
  const first = value.split(';')[0]
    .replace(/\([^)]*\)/g, '')
    .replace(/\s\d{4}(-\d{2,4})?/g, '')
    .replace(/\s+/g, ' ')
    .replace(/[,\s]+$/, '')
    .trim();
  const capped = first.charAt(0).toUpperCase() + first.slice(1);
  return capped.length > 32 ? `${capped.slice(0, 30)}…` : capped;
};

interface ChipProps {
  color: keyof typeof chipColors,
  label: string,
  caption: string,
}

const Chip = ({ color, label, caption }: ChipProps) => (
  <Tooltip caption={caption} wide>
    <span className={`text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${chipColors[color]}`}>
      {label}
    </span>
  </Tooltip>
);

interface Props {
  leader: Leader,
}

const FactChips = ({ leader }: Props) => {
  const { politics, politicalAffiliation, employment, jobTitle, excommunicated } = leader;

  if (!politics && !employment && !excommunicated) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1.5 pt-2">
      {excommunicated && <Chip color="excommunicated" label="Excommunicated" caption="Excommunicated (see positions and notes for dates)" />}
      {politicalAffiliation && politics && <Chip color="politics" label={politicalAffiliation} caption={politics} />}
      {employment && <Chip color="employment" label={jobTitle || shorten(employment)} caption={employment} />}
    </div>
  );
};

export default FactChips;
